import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import './styles.css';
import { useTranslation } from "react-i18next";



const LoadingProgress = ({ onComplete }) => {
    const [currentState, setCurrentState] = useState(0);
    const [progress, setProgress] = useState(0);
    const [categoriesLoaded, setCategoriesLoaded] = useState(false);
    const categories = useSelector((state) => state.categories);
    const { t } = useTranslation();

    const loadingStates = [
        { text: t("loading_maps") },
        { text: t('loading_tools') },
        { text: t('loading_indices') }
    ];
    // Check if categories are loaded
    useEffect(() => {
        const checkCategories = () => {
            const categoriesFromStorage = localStorage.getItem('categories');
            if (categories && Array.isArray(categories) && categories.length > 0) {
                setCategoriesLoaded(true);
            }
        };

        const intervalId = setInterval(checkCategories, 500);
        return () => clearInterval(intervalId);
    }, [categories]);

    // Progress bar animation
    useEffect(() => {
        if (!categoriesLoaded) {
            const progressInterval = setInterval(() => {
                setProgress(prev => {
                    const newProgress = prev + 0.5;
                    return newProgress >= 85 ? 85 : newProgress;
                });
            }, 50);

            return () => clearInterval(progressInterval);
        } else {
            setProgress(100);
            setTimeout(() => onComplete(), 2000);
        }
    }, [categoriesLoaded, onComplete]);

    // Cycle through loading states
    useEffect(() => {
        if (!categoriesLoaded) {
            const stateInterval = setInterval(() => {
                setCurrentState(prev =>
                    prev >= loadingStates.length - 1 ? 0 : prev + 1
                );
            }, 2000);

            return () => clearInterval(stateInterval);
        }
    }, [categoriesLoaded]);

    const currentText = categoriesLoaded ? t('finalizing') : loadingStates[currentState].text;

    return (
        <div className="loading-screen">
            <div className="loading-content">
                <AnimatePresence mode="wait">
                    <motion.div
                        key={currentText}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        className="state-text"
                    >
                        <Typography variant="h4">
                            {currentText}
                        </Typography>
                    </motion.div>
                </AnimatePresence>

                <div className="progress-wrapper">
                    <motion.div
                        className="progress-bar"
                        animate={{ width: `${progress}%` }}
                        transition={{ duration: 0.5 }}
                    />
                </div>
            </div>
        </div>
    );
};

export default LoadingProgress;